import type { GapBreakdown, GapTrend } from "@/api/encounters";
import { getGapBreakdown, getGapTrend } from "@/api/encounters";
import { useQuery } from "@tanstack/react-query";

import { toDateOnly } from "./useEncounterBreakdown";

interface UseGapBreakdownOptions {
  customerIds?: string[];
  dateFrom?: string;
  dateTo?: string;
}

export function useGapBreakdown(options?: UseGapBreakdownOptions) {
  const { customerIds, dateFrom, dateTo } = options ?? {};
  const dischargeDateFrom = toDateOnly(dateFrom);
  const dischargeDateTo = toDateOnly(dateTo);

  const { data, isLoading, error, refetch } = useQuery<GapBreakdown>({
    queryKey: ["gap-breakdown", customerIds?.join(","), dateFrom, dateTo],
    queryFn: () =>
      getGapBreakdown({
        customerIds: customerIds?.length ? customerIds : undefined,
        dischargeDateFrom,
        dischargeDateTo,
      }),
    staleTime: 30000,
    gcTime: 5 * 60 * 1000,
  });

  return { data, isLoading, error, refetch };
}

export function useGapTrend(options?: UseGapBreakdownOptions) {
  const { customerIds, dateFrom, dateTo } = options ?? {};
  const dischargeDateFrom = toDateOnly(dateFrom);
  const dischargeDateTo = toDateOnly(dateTo);

  const { data, isLoading, error, refetch } = useQuery<GapTrend>({
    queryKey: ["gap-trend", customerIds?.join(","), dateFrom, dateTo],
    queryFn: () =>
      getGapTrend({
        customerIds: customerIds?.length ? customerIds : undefined,
        dischargeDateFrom,
        dischargeDateTo,
      }),
    staleTime: 30000,
    gcTime: 5 * 60 * 1000,
  });

  return { data, isLoading, error, refetch };
}
